import { observer } from "mobx-react-lite";

import { useNodeThemeColors } from "@/components/expression/theme/useNodeTheme";
import * as Decorator from "@/components/expression/utils/decorators/Layout";
import { useIsSelected } from "@/components/expression/utils/layout";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

type Props = {
  node: DecoratorNodeModel;
  count?: number;
};

export const Dot = observer(function Dot({ node, count = 1 }: Props) {
  const { parent: symbolNode } = node;

  const theme = useNodeThemeColors(symbolNode?.parent);
  const isSelected = useIsSelected(symbolNode?.parent);
  const { view, size } = useNodeStyle();

  const isTextView = view === "text";
  const smallerSize = size === "xs" || size === "xxs" || size === "xxxs";

  return (
    <Decorator.HatBackground
      wide={count > 1}
      hatClassName={twMerge(
        !isTextView &&
          theme?.background &&
          `bg-${theme.background.light} dark:bg-${theme.background.dark}`,
        !isTextView && isSelected && `fromSm:bg-selected-bg`,
      )}
    >
      {...Array.from({ length: count }).map((_, i) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`${node.name}-${i}`}
          className={twMerge(
            "w-[3px] h-[3px] bg-document-text rounded-full flex-shrink-0",

            count > 3 && "w-[2.5px] h-[2.5px]",
            smallerSize && "w-[2px] h-[2px]",

            theme?.symbol && `bg-${theme.symbol.light} dark:bg-${theme.symbol.dark}`,
          )}
        />
      ))}
    </Decorator.HatBackground>
  );
});
